import { render, staticRenderFns } from "./JoinRide.vue?vue&type=template&id=1cb6a998&scoped=true"
import script from "./JoinRide.vue?vue&type=script&lang=js"
export * from "./JoinRide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb6a998",
  null
  
)

export default component.exports